import { Fragment } from 'react'
import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions, SERPPreviewActions } from 'actions'
import { SEOSettingsStore, SERPPreviewStore } from 'stores'
import Helmet from 'react-helmet'
import { Nav, Loading, SERPPreview, Button, SupportForm } from 'components'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import Formsy from 'formsy-react'
import { FormsyText, FormsyCheckbox } from 'formsy-material-ui'
import { SUPPORT_URL } from 'consts'

import EditStructuredData from './EditStructuredData'
import EditLocalBusiness from './EditLocalBusiness'

//import './editTitleDescriptionTemplate.scss'

const controlledSettings = [
  'pageTitleTruncateChars',
  'pageTitleEnableAppender',
  'pageTitleAppenderTemplate',
  'pageTitleAppenderTargetLength',
  'pageTitleTemplateApplyToAll',
  'metaDescriptionTruncateChars',
  'metaDescriptionTemplateApplyToAll',
  'structuredDataSocialProfileLinks',
  'structuredDataReviewApp',
  'structuredDataDisplayLocalBusiness',
  'structuredDataBusinessName',
  'structuredDataShopUrl',
  'structuredDataBusinessEmail',
  'structuredDataContactPhone',
  'structuredDataStreet',
  'structuredDataLocality',
  'structuredDataRegion',
  'structuredDataCountry',
  'structuredDataPostalCode'
]

export default class EditOtherSettings extends React.Component {
  static propTypes = {
    params:           React.PropTypes.object.isRequired,
    settings:         React.PropTypes.object.isRequired,
    fetching:         React.PropTypes.bool,
    shopDetails:      React.PropTypes.object,
    noShopDetails:    React.PropTypes.bool
  }

  constructor(props) {
    super(props)
    const resource = props.params.resource
    const friendlyName =
      resource === 'structured-data' ? 'Structured Data'
      : resource[0].toUpperCase() + resource.substr(1)
    this.state = {
      friendlyName,
      hasLogo: props.settings['structuredDataLogo.png']
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.settings) return

    this.setState({ hasLogo: newProps.settings['structuredDataDisplayLogo'] })
  }

  save(data) {
    let settings = {}
    controlledSettings.forEach((setting) => {
      settings[setting] = data[setting]
    })
    return SEOSettingsActions.update(settings)
  }

  render() {
    const label = this.props.fetching === true ? 'Saving...' : 'Save'

    return (
      <div>
        <Helmet title={`${this.state.friendlyName} - Plug in SEO Plus`} />
        <Nav toolbarTitleText={`${this.state.friendlyName}`} />
        <div className='seosettings'>
          <div className="seosettings__form-container">
          { this.props.params.resource === 'appender' &&
            <Formsy.Form onValidSubmit={::this.save}>
              <span>
                <div className='seosettings__row'>
                  <h2 className="small-spacing--bottom">Appender</h2>
                  <a href='https://support.pluginuseful.com/hc/en-us/articles/23534854922260-How-does-a-page-title-appender-help-my-SEO' target='_blank' className="body2">Help</a>
                  <FormsyText
                    defaultValue={this.props.settings.pageTitleAppenderTemplate}
                    disabled={this.props.fetching}
                    floatingLabelText='Template'
                    fullWidth={true}
                    name='pageTitleAppenderTemplate'
                    className="spacing__large"
                    fullWidth={true}
                  />
                  <FormsyText
                    defaultValue={this.props.settings.pageTitleAppenderTargetLength}
                    disabled={this.props.fetching}
                    floatingLabelText='Target length'
                    fullWidth={true}
                    name='pageTitleAppenderTargetLength'
                    validations='isNumeric'
                    validationError='Please enter only numbers'
                    className="large-spacing2--bottom"
                    fullWidth={true}
                  />
                  <FormsyCheckbox
                    label='Enabled'
                    name='pageTitleEnableAppender'
                    disabled={this.props.fetching}
                    defaultChecked={this.props.settings.pageTitleEnableAppender}
                    className="large-spacing--bottom"
                  />
                </div>
              </span>
              <div className='seosettings__row'>
                <Button
                  type='Submit'
                  label={label}
                  buttonType="primary"
                  disabled={this.props.fetching}
                />
              </div>
            </Formsy.Form>
          }
          { this.props.params.resource === 'advanced' &&
            <Formsy.Form onValidSubmit={::this.save}>
              <span>
                <div className='seosettings__row'>
                  <h2 className="small-spacing--bottom">Advanced</h2>
                  <a href='https://support.pluginuseful.com/hc/en-us/articles/23534846096404-How-do-I-set-up-my-page-title-and-meta-description-settings' target='_blank' className="body2">Help</a>
                  <h4 className="large-spacing2--top test">Page titles</h4>
                  <FormsyText
                    floatingLabelText='Truncate over (characters)'
                    defaultValue={this.props.settings.pageTitleTruncateChars}
                    disabled={this.props.fetching}
                    name='pageTitleTruncateChars'
                    validations='isNumeric'
                    validationError='Please enter only numbers'
                    fullWidth={true}
                  />
                  <FormsyCheckbox
                    label={<p className="body2">Override manually entered page titles with templates</p>}
                    defaultChecked={this.props.settings.pageTitleTemplateApplyToAll}
                    disabled={this.props.fetching}
                    name='pageTitleTemplateApplyToAll'
                    className="small-spacing2--top xlarge-spacing2--bottom"
                  />
                  <h4>Meta descriptions</h4>
                  <FormsyText
                    floatingLabelText='Truncate over (characters)'
                    defaultValue={this.props.settings.metaDescriptionTruncateChars}
                    disabled={this.props.fetching}
                    name='metaDescriptionTruncateChars'
                    validations='isNumeric'
                    validationError='Please enter only numbers'
                    fullWidth={true}
                  />
                  <FormsyCheckbox
                    label={<p className="body2">Override manually entered meta descriptions with templates</p>}
                    defaultChecked={this.props.settings.metaDescriptionTemplateApplyToAll}
                    disabled={this.props.fetching}
                    name='metaDescriptionTemplateApplyToAll'
                    className="small-spacing2--top xlarge-spacing2--bottom"
                  />
                </div>
              </span>
              <div className='seosettings__row'>
                <Button
                  type='Submit'
                  label={label}
                  buttonType="primary"
                  disabled={this.props.fetching}
                />
              </div>
            </Formsy.Form>
          }
          { this.props.params.resource === 'structured-data' &&
            <div>
              <EditStructuredData
                data={this.props.settings}
                onSave={this.save}
                saving={this.props.fetching}
                afterLogoUpload={() => this.setState({ hasLogo: true })}
                afterLogoDelete={() => this.setState({ hasLogo: false })}
              />
              {(this.props.shopDetails || this.props.noShopDetails) &&
                <EditLocalBusiness
                  data={this.props.settings}
                  details={this.props.shopDetails}
                  noDetails={this.props.noShopDetails}
                  onSave={this.save}
                  hasLogo={this.state.hasLogo}
                />
              }
            </div>
          }
          </div>
          <div className="seosettings__feedback-container">
            <SupportForm
              href={SUPPORT_URL}
              featureType="SEO settings"
              featureKey={`settings_${this.props.params.resource}`}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/EditOtherSettings.js